import AddBusinessDetails from 'app/features/profile/businessDetails/addBusinessDetails';
import EditBusinessDetails from 'app/features/profile/businessDetails/editBusinessDetails';
import PreviewBusinessDetails from 'app/features/profile/businessDetails/previewBusinessDetails';
import ViewBusinessDetails from 'app/features/profile/businessDetails/viewBusinessDetails';
import { UserRoleEnum } from 'app/services/user';
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoutes from 'utils/ProtectedRoutes';
import { ProtectedRoleRoute } from 'utils/RequireAuth';

export default function BusinessesRoutes() {
  return (
    <>
      <Route path="businesses">
        <Route path="" element={<ViewBusinessDetails />} />
        <Route path=":businessId" element={<PreviewBusinessDetails />} />
        <Route
          element={
            <ProtectedRoleRoute
              roles={[UserRoleEnum.ADMIN, UserRoleEnum.CLIENT]}
            />
          }
        >
          <Route path=":businessId/edit" element={<EditBusinessDetails />} />
          <Route path="create" element={<AddBusinessDetails />} />
        </Route>
      </Route>
    </>
  );
}
